export const VALIDATION_NAVIGATION_EVENT = 'sysmadd:validation-navigation';

export function revealValidationTarget(targetId?: string, fallbackId?: string) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  window.dispatchEvent(new CustomEvent(VALIDATION_NAVIGATION_EVENT));

  const reveal = (attempt: number) => {
    const target = (targetId ? document.getElementById(targetId) : null)
      || (fallbackId ? document.getElementById(fallbackId) : null);

    if (!target) {
      if (attempt < 8) window.setTimeout(() => reveal(attempt + 1), 40);
      return;
    }

    if (typeof (target as any).scrollIntoView === 'function') {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    const focusTarget = (
      target.matches('input, select, textarea, button, [tabindex]')
        ? target
        : target.querySelector('input, select, textarea, button, [tabindex]')
    ) as HTMLElement | null;

    if (focusTarget) {
      if (typeof focusTarget.focus === 'function') {
        focusTarget.focus({ preventScroll: true });
      }
      return;
    }

    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    if (typeof target.focus === 'function') {
      target.focus({ preventScroll: true });
    }
  };

  window.setTimeout(() => reveal(0), 0);
}
